import auth from "@/store";
// import jwt from "jsonwebtoken";

export default [
  {
    path: "/admin",
    name: "admin",
    component: () => import("@/views/admin/layouts/Admin.vue"),

    beforeEnter: (to, from, next) => {
      let user = { role: auth.getters["auth/userRole"] };
      if (["admin", "author", "leader", "intern"].includes(user.role)) {
        next();
      } else {
        next({ name: "home" });
      }
    },
    children: [
      {
        path: "user",
        name: "admin-user",
        // component: () => import("@/views/admin/pages/home/Home.vue"),
        component: () => import("@/views/admin/pages/user/User.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "session-details",
        name: "session-details",
        // component: () => import("@/views/admin/pages/home/Home.vue"),
        component: () =>
          import("@/views/admin/pages/user/components/SessionDetails.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-product",
        name: "admin-addproduct",
        component: () =>
          import("@/views/admin/pages/add-product/AddProduct.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "vendor-listing",
        name: "e-commerce-admin-vendorlisting",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addtags" */ "../pages/vendor-listing/VendorListing.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "vendor-transactions",
        name: "e-commerce-admin-vendortransactions",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addtags" */ "../pages/vendor-transactions/VendorTransactions.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-sub-category",
        name: "e-commerce-admin-addsubcategory",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addcategory" */ "../pages/add-sub-category/AddSubCategory.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-commission",
        name: "e-commerce-admin-commission",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addcategory" */ "../pages/commission/Commission.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-couponcode",
        name: "e-commerce-admin-couponcode",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addcategory" */ "../pages/coupon-code/CouponCode.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-subscriptions",
        name: "e-commerce-admin-subscriptions",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addcategory" */ "../pages/subscriptions/Subscriptions.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-page",
        name: "admin-page",
        component: () => import("@/views/admin/pages/add-pages/AddPage.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-banner",
        name: "admin-addbanner",
        component: () => import("@/views/admin/pages/add-banner/AddBanner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-tags",
        name: "admin-addtags",
        component: () => import("@/views/admin/pages/add-tags/AddTags.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-category",
        name: "admin-addcategory",
        component: () =>
          import("@/views/admin/pages/add-category/AddCategory.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "add-menu",
        name: "admin-menu",
        component: () => import("@/views/admin/pages/add-menu/AddMenu.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "sales-report",
        name: "admin-reports",
        component: () =>
          import("@/views/admin/pages/sales-report/SalesReport.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "taxes",
        name: "admin-taxes",
        component: () => import("@/views/admin/pages/taxes/Taxes.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "subscriberplan",
        name: "admin-subscriberplan",
        component: () =>
          import("@/views/admin/pages/add-subscriber/SubscriberPlan.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "analytics",
        name: "admin-analytics",
        component: () => import("@/views/admin/pages/analytics/Analytics.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "addnewpage",
        name: "admin-addnewpage",
        component: () =>
          import("@/views/admin/pages/add-pages/components/NewPage.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "integrations",
        name: "integrations",
        component: () =>
          import("@/views/admin/pages/integrations/integrations.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "custom-duty",
        name: "custom-duty",
        component: () =>
          import("@/views/admin/pages/custom-duty/CustomDuty.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "order-management",
        name: "order-management",
        component: () => import("@/views/admin/pages/order-mgmt/OrderMgmt.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "customer-management",
        name: "customer-management",
        component: () =>
          import("@/views/admin/pages/cust-mgmt/CustomerMgmt.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "shipway-integration",
        name: "shipway-integration",
        component: () =>
          import(
            "@/views/admin/pages/shipway-integration/ShipwayIntegration.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "contactus",
        name: "contactus",
        component: () => import("@/views/admin/pages/contact-us/ContactUs.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "manage-seller-review",
        name: "seller-review",
        component: () =>
          import("@/views/admin/pages/seller-review/SellerReview.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "posts",
        name: "posts",
        component: () => import("@/views/admin/pages/post/Post.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "comments",
        name: "comments",
        component: () => import("../pages/post/components/CommentTable.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "replies",
        name: "replies",
        component: () => import("../pages/post/components/ReplyTable.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      //super-admin
      {
        path: "Super-admin",
        name: "Super-admin",
        component: () =>
          import("@/views/admin/pages/super-admin/SuperAdmin.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "user",
        name: "user",
        component: () => import("@/views/admin/pages/user/User.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "channel",
        name: "channel",
        component: () => import("@/views/admin/pages/channel/Channel.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      //Respite care
      {
        path: "respite-care",
        name: "Respite-care",
        component: () => import("@/views/respite-care/Respite-care.vue"),
      },

      {
        path: "admin-analyticss",
        name: "admin-analyticss",
        component: () =>
          import("@/views/admin/pages/admin-analytics/SalesReport.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "campaign-list",
        name: "campaign-list",
        component: () =>
          import("@/views/admin/pages/campaign-list/Campaigns.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "sms",
        name: "campaign-sms",
        component: () =>
          import("@/views/admin/pages/campaign-list/sms/SMS.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "e-mail",
        name: "e-mail",
        component: () =>
          import("@/views/admin/pages/campaign-list/e-mail/E-mail.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "voice-blast",
        name: "voiceBlast",
        component: () =>
          import("@/views/admin/pages/campaign-list/voice/VoiceBlast.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      // {
      //   path: "home-pages",
      //   name: "home-pages",
      //   // component: () => import("@/views/social/admin/pages/blog/Blog.vue"),

      //   meta: {
      //     rule: "editor",
      //     authRequired: true,
      //   },
      // },

      {
        path: "announcement",
        name: "announcement",
        component: () => import("../pages/add-announcement/announcement.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "testimonial",
        name: "testimonial",
        component: () => import("../pages/admintestmonial/Testmonialadmin.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "homePageBanner",
        name: "homePageBanner",
        component: () =>
          import("../pages/add-homePageBanner/homePageBanner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "admin-ffc",
        name: "admin-ffc",
        component: () => import("../pages/admin-ffc/ffc.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "ffc-banner",
        name: "ffc-banner",
        component: () => import("../pages/admin-ffc-banner/ffc_banner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-ffc-banner",
        name: "add-ffc-banner",
        component: () => import("../pages/admin-ffc-banner/AddBanner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "edit-ffc-banner",
        name: "edit-ffc-banner",
        component: () => import("../pages/admin-ffc-banner/EditBanner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "ffc-partner",
        name: "ffc-partner",
        component: () => import("../pages/admin-ffc-partner/ffc_partner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-ffc-partner",
        name: "add-ffc-partner",
        component: () => import("../pages/admin-ffc-partner/AddPartner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "edit-ffc-partner",
        name: "edit-ffc-partner",
        component: () => import("../pages/admin-ffc-partner/EditPartner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "ffc-testimonial",
        name: "ffc-testimonial",
        component: () =>
          import("../pages/admin-ffc-testimonial/ffc_testimonial.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "ffc-hub",
        name: "ffc-hub",
        component: () => import("../pages/admin-ffc-hub/ffc_hub.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "corporate-event",
        name: "corporate-event",
        component: () => import("../pages/corporates/Corporates"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "future-trend",
        name: "future-trend",
        component: () => import("../pages/future-trends/Future.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "well-being",
        name: "well-being",
        component: () => import("../pages/well-being/WellBeing.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "ffc-podcasts",
        name: "ffc-podcasts",
        component: () => import("../pages/ffc-podcast/Podcast.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "ffc-registeration",
        name: "ffc-registeration",
        component: () => import("../pages/ffc-registeration/Registeration.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-ffc-hub",
        name: "add-ffc-hub",
        component: () => import("../pages/admin-ffc-hub/AddHub.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "edit-ffc-hub",
        name: "edit-ffc-hub",
        component: () => import("../pages/admin-ffc-hub/EditHub.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "ffc-review",
        name: "ffc-review",
        component: () => import("../pages/admin-ffc-review/ffc_review.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "aboutus-banner",
        name: "aboutus-banner",
        component: () => import("../pages/admin-aboutus-banner/banner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-aboutus-banner",
        name: "add-aboutus-banner",
        component: () => import("../pages/admin-aboutus-banner/AddBanner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "edit-aboutus-banner",
        name: "edit-aboutus-banner",
        component: () => import("../pages/admin-aboutus-banner/EditBanner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "aboutus-main",
        name: "aboutus-main",
        component: () => import("../pages/admin-aboutus-main/main.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-aboutus-main",
        name: "add-aboutus-main",
        component: () => import("../pages/admin-aboutus-main/Add.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "edit-aboutus-main",
        name: "edit-aboutus-main",
        component: () => import("../pages/admin-aboutus-main/Edit.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "homepage-aboutus",
        name: "homepage-aboutus",
        component: () => import("../pages/admin-homepage-aboutus/aboutus.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-homepage-aboutus",
        name: "add-homepage-aboutus",
        component: () => import("../pages/admin-homepage-aboutus/Add.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "edit-homepage-aboutus",
        name: "edit-homepage-aboutus",
        component: () => import("../pages/admin-homepage-aboutus/Edit.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "affiliate-products",
        name: "affiliate-products",
        component: () => import("../pages/add-product/AddProduct.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "view-profile",
        name: "view-profile",
        component: () =>
          import("@/views/admin/pages/user/components/ViewProfile.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "editannouncement",
        name: "editannouncement",
        component: () =>
          import("../pages/add-announcement/components/EditAnnouncement.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "edithomepagebanner",
        name: "edithomepagebanner",
        component: () =>
          import("../pages/add-homePageBanner/components/EditBanner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "playlist-category",
        name: "playlist-category",
        component: () =>
          import("../pages/admin-playlist-category/category.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-playlist-category",
        name: "add-playlist-category",
        component: () =>
          import("../pages/admin-playlist-category/AddCategory.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "edit-playlist-category",
        name: "edit-playlist-category",
        component: () =>
          import("../pages/admin-playlist-category/EditCategory.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "admin-playlist",
        name: "admin-playlist",
        component: () => import("../pages/admin-playlist/admin-playlist.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-playlist",
        name: "add-playlist",
        component: () => import("../pages/admin-playlist/AddPlaylist.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "edit-playlist",
        name: "edit-playlist",
        component: () => import("../pages/admin-playlist/EditPlaylist.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "admin-episode",
        name: "admin-episode",
        component: () => import("../pages/admin-episode/episode.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-episode",
        name: "add-episode",
        component: () => import("../pages/admin-episode/AddEpisode.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "edit-episode",
        name: "edit-episode",
        component: () => import("../pages/admin-episode/EditEpisode.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "playlist-form",
        name: "playlist-form",
        component: () =>
          import("../pages/admin-playlist-form/playlist-form.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "blogs",
        name: "blogs",
        component: () => import("@/views/social/admin/pages/blog/Blog.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "author",
        name: "author",
        component: () => import("@/views/social/admin/pages/author/Author.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "doctor",
        name: "doctor",
        component: () => import("@/views/social/admin/pages/doctor/Doctor.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "podcasts",
        name: "podcasts",
        component: () =>
          import("@/views/social/admin/pages/Podcast/podcasts.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "news-panel",
        name: "news-panel",
        component: () => import("@/views/social/admin/pages/news/News.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "careers-panel",
        name: "careers-panel",
        component: () =>
          import("@/views/social/admin/pages/careers/ListCareer.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "about-panel",
        name: "about-panel",
        component: () =>
          import("@/views/social/admin/pages/about-us/About.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "events-panel",
        name: "events-panel",
        component: () => import("@/views/social/admin/pages/events/Events.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "corporate-booking",
        name: "admin-corporateBooking",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addcategory" */ "../pages/add-corporateBooking/CorporateBooking.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-booking",
        name: "admin-addbooking",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addcategory" */ "@/views/admin/pages/add-booking/Booking.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "edit-corporateBooking",
        name: "editbooking",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addcategory" */ "@/views/admin/pages/add-corporateBooking/components/EditBooking.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "edit-companydash",
        name: "editdash",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addcategory" */
            "@/views/admin/pages/company-dashboard/components/Editdash.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "company-dashboard",
        name: "admin-dashboard",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addcategory" */
            "@/views/admin/pages/company-dashboard/CompanyDashboard.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "selfhelp-panel",
        name: "selfhelp",
        component: () =>
          import("@/views/social/admin/pages/selfhelp/Selfhelp.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "admin-tag",
        name: "admin-tag",
        component: () =>
          import("@/views/social/admin/pages/add-tags/AddTags.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "add-blogs",
        name: "addblogcontent",
        component: () => import("@/views/social/admin/pages/blog/Add.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-product",
        name: "addproductcontent",
        component: () =>
          import("@/views/social/admin/pages/affiliate/Addaffiliate.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "blog/edit",
        name: "social-admin-edit-blog",
        component: () =>
          import(
            /* webpackChunkName: "social-admin-add-blog" */ "@/views/social/admin/pages/blog/Edit.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "add-exclusive-blog",
        name: "addexclusiveblogcontent",
        component: () =>
          import("@/views/social/admin/pages/admin-exclusive/AddExclusive.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "blog-exc/edit-exc",
        name: "social-admin-edit-exclusive",
        component: () =>
          import(
            "@/views/social/admin/pages/admin-exclusive/EditExclusive.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "Service_Exclusive_Table",
        name: "service_exclusive_table",
        component: () =>
          import(
            "@/views/social/admin/pages/admin-exclusive/BlogExclusive.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-partnership-blog",
        name: "addpartnershipblogcontent",
        component: () =>
          import(
            "@/views/social/admin/pages/admin-partnership/AddPartnership.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "service-partner",
        name: "service-partner",
        component: () =>
          import(
            "@/views/social/admin/pages/admin-partnership/BlogPartnership.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "service-edit-partner",
        name: "service-edit-partner",
        component: () =>
          import(
            "@/views/social/admin/pages/admin-partnership/EditPartnership.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "add-offers-blog",
        name: "addoffersblogcontent",
        component: () =>
          import("@/views/social/admin/pages/admin-offers/AddOffers.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "service-edit-offer",
        name: "service-edit-offer",
        component: () =>
          import("@/views/social/admin/pages/admin-offers/EditOffers.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      // banner
      {
        path: "add-banner",
        name: "addbannercontent",
        component: () =>
          import("@/views/social/admin/pages/admin-banner/AddBanner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "admin-brand",
        name: "admin-brand",
        component: () =>
          import("@/views/social/admin/pages/admin-brand/Brand.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "admin-banner",
        name: "admin-banner",
        component: () =>
          import("@/views/social/admin/pages/admin-banner/Banner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "admin-mis",
        name: "admin-mis",
        component: () => import("../../admin/pages/admin-mis/AdminMIS.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "service-edit-banner",
        name: "service-edit-banner",
        component: () =>
          import("@/views/social/admin/pages/admin-banner/EditBanner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "service-banner-table",
        name: "service-banner-table",
        component: () =>
          import("@/views/social/admin/pages/admin-banner/Banner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "/admin/career-panel/create-careers-content",
        name: "create-career",
        component: () =>
          import(
            "@/views/social/admin/pages/careers/components/CreateCareer.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/career-panel/edit-careers-content",
        name: "editCareer",
        component: () =>
          import(
            "@/views/social/admin/pages/careers/components/EditCareer.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/selfhelp-panel/addselfhelp",
        name: "addselfhelp",
        component: () =>
          import(
            "@/views/social/admin/pages/selfhelp/components/AddSelfhelp.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/selfhelp-panel/editselfhelp",
        name: "editselfhelp",
        component: () =>
          import(
            "@/views/social/admin/pages/selfhelp/components/EditSelfHelp.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/selfhelp-panel/addPodcast",
        name: "addPodcast",
        component: () =>
          import(
            "@/views/social/admin/pages/Podcast/components/AddPodcast.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/selfhelp-panel/editPodcast",
        name: "editPodcast",
        component: () =>
          import(
            "@/views/social/admin/pages/Podcast/components/EditPodcast.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/events-panel/add-events",
        name: "addEvents",
        component: () =>
          import(
            "@/views/social/admin/pages/events/components/CreateEvent.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/events-panel/edit-event",
        name: "editEvent",
        component: () =>
          import("@/views/social/admin/pages/events/components/EditEvent.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/news-panel/add-news",
        name: "addnewscontent",
        component: () =>
          import("@/views/social/admin/pages/news/components/AddNews.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/news-panel/edit-news",
        name: "editNews",
        component: () =>
          import("@/views/social/admin/pages/news/components/EditNews.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "/admin/announcement/add-announcement",
        name: "addannouncementcontent",
        component: () =>
          import("../pages/add-announcement/components/AddAnnouncement.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/announcement/edit-announcement",
        name: "editAnnouncement",
        component: () =>
          import("../pages/add-announcement/components/EditAnnouncement.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/homepagebanner/add-Banner",
        name: "addHomePageBanner",
        component: () =>
          import("../pages/add-homePageBanner/components/AddBanner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/homepagebanner/edit-banner",
        name: "editHomePageBanner",
        component: () =>
          import("../pages/add-homePageBanner/components/EditBanner.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "group",
        name: "group",
        component: () =>
          import("@/views/admin/pages/campaign-list/group/Group.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "reports",
        name: "reports",
        component: () =>
          import("@/views/admin/pages/campaign-list/reports/Reports.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "transactions",
        name: "transactions",
        component: () =>
          import(
            "@/views/admin/pages/campaign-list/transactions/Transactions.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "AddNumberForm",
        name: "addnumber-form",
        component: () =>
          import(
            "@/views/admin/pages/campaign-list/group/components/AddNumberForm.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "setting",
        name: "setting",
        component: () =>
          import("@/views/admin/pages/campaign-list/setting/Setting.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "logo",
        name: "logo",
        component: () =>
          import(
            /* webpackChunkName: "social-admin-logo" */ "../pages/logo/Logo.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "couponmanagement",
        name: "e-commerce-admin-couponmanagement",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addcategory" */ "../pages/coupon-management/CouponM.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "feature",
        name: "feature",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addcategory" */ "../pages/feature/Feature.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "addcategories",
        name: "addcategories",
        component: () =>
          import(
            /* webpackChunkName: "e-commerce-admin-addcategory" */ "../pages/addcategories/AddCategories.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "scope",
        name: "scope",
        component: () => import("@/views/admin/pages/scope/Scope.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "My Account",
        name: "myaccount",
        component: () => import("@/views/admin/pages/myaccount/MyAccount.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "add-training",
        name: "admin-training",
        component: () =>
          import(
            "@/views/admin/pages/add-coursecategory/AddCourseCategory.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-course",
        name: "admin-coursesdetails",
        component: () => import("@/views/admin/pages/add-course/Courses.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "coursecustomizedetails",
        name: "admin-coursecustomizedetails",
        component: () =>
          import("@/views/admin/pages/add-course/components/Customize.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "Attendees",
        name: "admin-Attendees",
        component: () =>
          import("@/views/admin/pages/add-course/components/Attendees.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "brochure",
        name: "admin-brochure",
        component: () =>
          import("@/views/admin/pages/coach/brochure/Brochure.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "announce",
        name: "admin-announce",
        component: () =>
          import("@/views/admin/pages/coach/announce/Announce.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "addcoach",
        name: "add-coach",
        component: () =>
          import("@/views/admin/pages/coach/brochure/components/AddCoach.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "EditCoach",
        name: "edit-coach",
        component: () =>
          import("@/views/admin/pages/coach/brochure/components/EditCoach.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "sessiondates",
        name: "admin-sessiondates",
        component: () =>
          import("@/views/admin/pages/coach/sessiondate/SessionDates.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "mantras",
        name: "admin-mantras",
        component: () =>
          import("@/views/admin/pages/application/mantras/Mantras.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "artworks",
        name: "admin-artworks",
        component: () =>
          import("@/views/admin/pages/heartofcare/artworks/ArtWorks.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "meditation",
        name: "meditation",
        component: () =>
          import("@/views/admin/pages/meditation/Meditation.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "getApp",
        name: "getApp",
        component: () => import("@/views/admin/pages/getApp/getApp.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "donor",
        name: "donor",
        component: () => import("@/views/admin/pages/donor/donor.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "wishes",
        name: "wishes",
        component: () => import("@/views/admin/pages/donor/WishTable.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "push",
        name: "admin-push",
        component: () => import("@/views/admin/pages/notification/Push.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "applicationclose",
        name: "application-close",
        component: () =>
          import(
            "@/views/admin/pages/coach/sessiondate/components/ApplicationClose.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-trainersdashboard",
        name: "admin-trainersDashboard",
        component: () =>
          import(
            "@/views/admin/pages/trainers-dashboard/TrainersDashboard.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "admin-plan",
        name: "admin-plan",
        component: () =>
          import("@/views/admin/pages/subscriptionplan/Plan.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "subscription-user",
        name: "subscription-user",
        component: () =>
          import("@/views/admin/pages/subscriptionUser/SubscriptionUser.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "rolemanagement",
        name: "admin-rolemanagement",
        component: () =>
          import("@/views/admin/pages/role-management/RoleManage.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "company-dashboard",
        name: "admin-companydashboard",
        component: () =>
          import("@/views/admin/pages/company-dashboard/CompanyDashboard.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "specialized-caregiver",
        name: "admin-specializedcaregiver",
        component: () =>
          import(
            "@/views/admin/pages/add-specializedcaregiver/SpecializedCaregiver.vue"
          ),
        beforeEnter: (to, from, next) => {
          try {
            let user = { role: auth.getters["auth/userRole"] };
            if (["admin"].includes(user.role)) {
              next();
            } else {
              next({ name: "home" });
            }
          } catch (error) {
            console.log(error);
          }
        },

        children: [
          {
            path: "specialized-table",
            name: "admin-table",
            component: () =>
              import(
                "@/views/admin/pages/add-specializedcaregiver/components/SpecializedTable.vue"
              ),

            meta: {
              rule: "editor",
              authRequired: true,
            },
          },
          {
            path: "application-reqtable",
            name: "application-reqTable",
            component: () =>
              import(
                "@/views/admin/pages/add-specializedcaregiver/components/ApplicationReqTable.vue"
              ),

            meta: {
              rule: "editor",
              authRequired: true,
            },
          },

          {
            path: "withdraw-reqtable",
            name: "withdraw-reqTable",
            component: () =>
              import(
                "@/views/admin/pages/add-specializedcaregiver/components/WithdrawReqTable.vue"
              ),

            meta: {
              rule: "editor",
              authRequired: true,
            },
          },
          {
            path: "service-provider-details",
            name: "service-provider-details",
            component: () =>
              import(
                "@/views/admin/pages/add-specializedcaregiver/components/ServiceProviderDetailsTable.vue"
              ),

            meta: {
              rule: "editor",
              authRequired: true,
            },
          },
        ],
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "admin-exclusive",
        name: "admin-exclusive",
        component: () =>
          import(
            "@/views/social/admin/pages/admin-exclusive/BlogExclusive.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "admin-partnership",
        name: "admin-partnership",
        component: () =>
          import(
            "@/views/social/admin/pages/admin-partnership/BlogPartnership.vue"
          ),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "admin-offers",
        name: "admin-offers",
        component: () =>
          import("@/views/social/admin/pages/admin-offers/BlogOffers.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "service-offers",
        name: "service-offers",
        component: () =>
          import("@/views/social/admin/pages/admin-offers/BlogOffers.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "vendor-details",
        name: "vendor-details",
        component: () =>
          import("@/views/admin/pages/vendordetails/VendorDetails.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "vendor-products",
        name: "vendor-products",
        component: () =>
          import("@/views/admin/pages/vendorproduct/VendorProducts.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/gallery",
        name: "gallery",
        component: () => import("@/views/admin/pages/gallery/Gallery.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/medical_cancer",
        name: "/admin/medical_cancer",
        component: () => import("@/views/admin/pages/medical/Medical.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/partners",
        name: "/admin/partners",
        component: () => import("@/views/admin/pages/partners/Partner.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/medical_faq",
        name: "/admin/medical_faq",
        component: () => import("@/views/admin/pages/medical_faq/Faq.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/medical-affiliate-url",
        name: "/admin/medical-affiliate-url",
        component: () =>
          import(
            "@/views/admin/pages/medical-affiliate-urls/MedicalAffiliateUrl.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/gallery-details",
        name: "gallery-details",
        component: () =>
          import("@/views/admin/pages/gallery/components/GalleryDetails.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/galleryDetails/:id",
        name: "galleryDetails",
        component: () =>
          import("@/views/admin/pages/gallery/components/GalleryDetails.vue"),
      },

      {
        path: "/admin/campaign",
        name: "campaign",
        component: () =>
          import(
            "@/views/admin/pages/add-campaign-banner/campaignPageBanner.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "/admin/campaign/add",
        name: "addCampaignPageBanner",
        component: () =>
          import(
            "@/views/admin/pages/add-campaign-banner/components/AddBanner.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/medical/add",
        name: "addMedical",
        component: () =>
          import("@/views/admin/pages/medical/components/AddBanner.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/medical/edit",
        name: "editMedical",
        component: () =>
          import("@/views/admin/pages/medical/components/EditBanner.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/partners/add",
        name: "addPartners",
        component: () =>
          import("@/views/admin/pages/partners/components/AddBanner.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/partners/edit",
        name: "editPartners",
        component: () =>
          import("@/views/admin/pages/partners/components/EditBanner.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/faq/add",
        name: "addFaq",
        component: () =>
          import("@/views/admin/pages/medical_faq/components/AddBanner.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/faq/edit",
        name: "editFaq",
        component: () =>
          import("@/views/admin/pages/medical_faq/components/EditBanner.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/campaign/edit",
        name: "editCampaignPageBanner",
        component: () =>
          import(
            "@/views/admin/pages/add-campaign-banner/components/EditBanner.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },

      {
        path: "/admin/aboutcampaign-banner",
        name: "aboutcampaign-banner",
        component: () =>
          import(
            "@/views/admin/pages/add-aboutcampaigns/campaignsHomeBanner.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/aboutcampaign-banner/add",
        name: "addCampaign-banner",
        component: () =>
          import(
            "@/views/admin/pages/add-aboutcampaigns/components/AddBanner.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/aboutcampaign-banner/edit",
        name: "editCampaign-banner",
        component: () =>
          import(
            "@/views/admin/pages/add-aboutcampaigns/components/EditBanner.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      /////
      {
        path: "/admin/campaign-home",
        name: "campaign-home",
        component: () =>
          import("@/views/admin/pages/add-campaign-home/campaignhome.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/campaign-home/add",
        name: "addCampaignHome",
        component: () =>
          import(
            "@/views/admin/pages/add-campaign-home/components/AddCampaign.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/campaign-home/edit",
        name: "editCampaignHome",
        component: () =>
          import(
            "@/views/admin/pages/add-campaign-home/components/EditCampaign.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      /////////////
      {
        path: "/admin/friends-updates",
        name: "friends-updates",
        component: () =>
          import("@/views/admin/pages/add-friends-updates/friends-updates.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/friends-updates/add",
        name: "addFriendsUpdates",
        component: () =>
          import(
            "@/views/admin/pages/add-friends-updates/components/AddUpdates.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/friends-updates/edit",
        name: "editFriendsUpdates",
        component: () =>
          import(
            "@/views/admin/pages/add-friends-updates/components/EditUpdates.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/campaign-partner",
        name: "campaign-partner",
        component: () =>
          import(
            "@/views/admin/pages/add-campaign-partner/campaign-partner.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/campaign-partner/add",
        name: "addCampaignPartner",
        component: () =>
          import("@/views/admin/pages/add-campaign-partner/AddPartner.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/campaign-partner/edit",
        name: "editCampaignPartner",
        component: () =>
          import("@/views/admin/pages/add-campaign-partner/EditPartner.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      /////////////////////
      {
        path: "/admin/campaign-reference",
        name: "campaign-reference",
        component: () =>
          import(
            "@/views/admin/pages/add-campaign-reference/campaign-reference.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/campaign-reference/add",
        name: "addCampaignReference",
        component: () =>
          import(
            "@/views/admin/pages/add-campaign-reference/components/AddReference.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/campaign-reference/edit",
        name: "editCampaignReference",
        component: () =>
          import(
            "@/views/admin/pages/add-campaign-reference/components/EditReference.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/regulation-policies-papers",
        name: "regulation-policies",
        component: () =>
          import(
            "@/views/admin/pages/add-regulation-docs/regulation-policy.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/regulation-policies-papers/add",
        name: "addRegulationPolicy",
        component: () =>
          import(
            "@/views/admin/pages/add-regulation-docs/components/AddRegulation.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/regulation-policies-papers/edit",
        name: "editRegulationPolicy",
        component: () =>
          import(
            "@/views/admin/pages/add-regulation-docs/components/EditRegulation.vue"
          ),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      ///////Quotes
      {
        path: "/admin/cms-quotes",
        name: "cms-quotes",
        component: () =>
          import("@/views/admin/pages/add-quotes/cms-quotes.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/cms-quotes/add",
        name: "addQuotes",
        component: () =>
          import("@/views/admin/pages/add-quotes/components/AddQuotes.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "/admin/cms-quotes/edit",
        name: "editQuotes",
        component: () =>
          import("@/views/admin/pages/add-quotes/components/EditQuotes.vue"),
        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      // podcast-category
      {
        path: "podcast-category",
        name: "podcast-category",
        component: () => import("../pages/admin-podcast-category/category.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-podcast-category",
        name: "add-podcast-category",
        component: () =>
          import("../pages/admin-podcast-category/AddCategory.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "edit-podcast-category",
        name: "edit-podcast-category",
        component: () =>
          import("../pages/admin-podcast-category/EditCategory.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      // podcast-episode
      {
        path: "podcast-episode",
        name: "podcast-episode",
        component: () => import("../pages/admin-podcast-episode/episode.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "add-podcast-episode",
        name: "add-podcast-episode",
        component: () =>
          import("../pages/admin-podcast-episode/AddEpisode.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
      {
        path: "edit-podcast-episode",
        name: "edit-podcast-episode",
        component: () =>
          import("../pages/admin-podcast-episode/EditEpisode.vue"),

        meta: {
          rule: "editor",
          authRequired: true,
        },
      },
    ],
    meta: {
      rule: "editor",
      authRequired: true,
    },
  },
];
